import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-lg border-[0.5px] px-2 py-0.5 text-[11px] font-semibold leading-none tabular-nums",
  {
    variants: {
      variant: {
        default: "border-[#DCDFE3] bg-[#ECEFF3] text-[#92989F]",
        read: "border-[#CDE9C3] bg-[#F0F9EC] text-[#288B03]",
        write: "border-[#FFE6C2] bg-[#FDF7E6] text-[#a16207]",
        destructive: "border-[#fecaca] bg-[#FEF2F2] text-[#b91c1c]",
        active: "border-[#c4a8db] bg-[#EDE0F5] text-[#713D98]",
        updated: "border-[#FFE6C2] bg-[#FDF7E6] text-[#a16207]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { badgeVariants };
